import React from 'react';

const ConfirmDeleteModal = ({ 
  isOpen, 
  onConfirm, 
  onCancel, 
  title = "¿Eliminar elemento?",
  message = "Esta acción no se puede deshacer.",
  itemName = "",
  isLoading = false,
  actionType = "delete"
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-lg border border-gray-300 w-full max-w-md p-6">
        {/* Favicon */}
        <div className="flex justify-center mb-4">
          <img 
            src="/assets/images/favicon.png" 
            alt="Logo" 
            className="w-12 h-12"
            onError={(e) => {
              e.target.src = "/src/assets/favicon.png";
            }}
          />
        </div>
        
        {/* Mensaje */}
        <div className="text-center mb-6">
          <p className="text-gray-700 mb-2">
            ¿Quiere eliminar el producto
          </p>
          {itemName && (
            <p className="font-medium text-gray-900 mb-2">
              "{itemName}"?
            </p>
          )}
        </div>
        
        {/* Botones */}
        <div className="flex gap-3 justify-center">
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="px-6 py-2 text-gray-700 border border-gray-300 rounded hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="px-6 py-2 text-white bg-red-600 rounded hover:bg-red-700 transition-colors disabled:opacity-50"
          >
            {isLoading ? 'Eliminando...' : 'Aceptar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;

